export default {
	props: {
		modelId: { type: Number, default: null },
		modelType: { type: Number, default: null },
		editingModel: { type: Object, deafult: null },
		options: { type: Object, default: null },
		minimised: { type: Boolean, default: false },
		_options: { type: Object, default: null },
		lastModal: { type: Object, default: null },
	},

	data() {
		return {
			value: null,
			action: null,
			saving: false,
			user: this.$authSanctum.getUser(),
		}
	},

	created() {
		console.log('modal mixin created', this.value)

		this.$event.$on('modal-close', () => {
			this.value = null
			this.action = null
			this.saving = false
			this.user = null
		})
	},

	unmounted() {
		// console.log('modal mixin unmounted')
		this.value = null
		this.action = null
		this.saving = false
		this.user = null
		// console.log('unmounted', this.value);
	},

	methods: {
		requiresCRMFunds() {
			if (this.user.crmOutOfFunds()) {
				// this.$emit('close')
				this.$event.$emit('modal-open', {
					view: 'CrmOutOfFunds',
				})
			}
		},

		setup(model) {
			// console.log('modal setup', model.form(this.editingModel))

			this.value = null
			this.value = model.form(this.editingModel)

			if (this.action == null || this.action == undefined) {
				this.action = model.route(this.editingModel == null ? 'create' : 'edit', this.editingModel?.id)
			}
		},

		isSaving(form) {
			return form || this.saving
		},

		redirectAfterSubmit(event, path) {
			if (event.submitter.name == 'redirect_after' && event.submitter.value == 1) {
				this.value = {}
				this.$event.$emit('modal-close')
				this.$router.push({ path: path })
			}
		},
	},

	computed: {
		isEdit() {
			return this.editingModel != null && this.editingModel.id != null
		},
	},
}
